import numeral from 'numeral';

export function formatCurrency(value, symbol, numeralFormat = '0,0.00') {
  return `${symbol}${numeral(value).format(numeralFormat)}`;
}

export function format(value,formatParam='') {
  let [format,numeralFormat] = ((angular.isFunction(formatParam)) ? formatParam() : formatParam).split(':');

  switch(format.toLowerCase()) {
    case 'date':
      return moment.utc(value).format('D.MM.YYYY');
    case 'datetime':
      return moment.utc(value).format('D.MM.YYYY H:mm');
    case 'number':
      numeralFormat = numeralFormat || '0,0';
      return numeral(value).format(numeralFormat);
    case 'eur':
      return formatCurrency(value, '€', numeralFormat);
    case 'usd':
      return formatCurrency(value, '$', numeralFormat);
    case 'gbp':
      return formatCurrency(value, '£', numeralFormat);
    case 'jpy':
      return formatCurrency(value, '¥', numeralFormat);
    case 'percentage':
      return numeral(value ? value / 100 : 0).format(numeralFormat || '0,0.00%');
    default:
      return value;
  }
}

export function formatDate(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 1-12
  const day = date.getDate();

  const pad2 = (n) => {
    const s = String(n);
    if (angular.isFunction(s.padStart)) {
      return s.padStart(2, '0');
    }
    return ('0' + s).slice(-2);
  };

  return `${year}-${pad2(month)}-${pad2(day)} 00:00:00`;
}

export function apiDate(date) {
    let asDate = new Date(date);
    return formatDate(asDate);
}
export function apiDateMinusDays(date, days) {
  return moment.utc(date).subtract(days, "days").format('YYYY-MM-DD 00:00:00');
}

export default angular.module('app.format', [])
  .filter('format', function() {
    return format;
  })
  .filter('apiDate', function() {
    return apiDate;
  })
  .filter('apiDateMinusDays', function() {
    return apiDateMinusDays;
  })



/** WEBPACK FOOTER **
 ** ./src/filters/format.js
 **/